import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const { user } = useAuth();
    const [cart, setCart] = useState({ items: [], subtotal: 0 });
    const [wishlist, setWishlist] = useState({ items: [] });

    const load = useCallback(async () => {
        if (!user) { setCart({ items: [], subtotal: 0 }); setWishlist({ items: [] }); return; }
        try {
            const [c, w] = await Promise.all([api.get("/cart"), api.get("/wishlist")]);
            setCart(c.data); setWishlist(w.data);
        } catch (e) { /* ignore */ }
    }, [user]);

    useEffect(() => { load(); }, [load]);

    const addToCart = async (product_id, size, quantity = 1) => {
        const { data } = await api.post("/cart/items", { product_id, size, quantity });
        setCart(data);
    };
    const updateCart = async (product_id, size, quantity) => {
        const { data } = await api.put("/cart/items", { product_id, size, quantity });
        setCart(data);
    };
    const removeCart = async (product_id, size) => {
        const { data } = await api.delete("/cart/items", { params: { product_id, size } });
        setCart(data);
    };
    const addWishlist = async (product_id) => { await api.post("/wishlist", { product_id }); load(); };
    const removeWishlist = async (product_id) => { await api.delete(`/wishlist/${product_id}`); load(); };
    const isWishlisted = (id) => wishlist.items.some(i => i.id === id);

    return (
        <CartContext.Provider value={{ cart, wishlist, addToCart, updateCart, removeCart, addWishlist, removeWishlist, isWishlisted, refresh: load }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
